export default function ForgotPasswordRespTemplate(data) {
    //language=HTML
    return `
        <div id="example" style="margin-top: 60px">
            <div class="container">
                <div class="col-md-8 col-md-offset-2">
                    <section class="well">
                        <h2 class="ra-well-title">${data.translateId("pleaseChangPassword")}</h2>
                        <div class="form-horizontal form-widgets col-md-8 col-md-offset-2 clearfix">
                            <div class="form-group">
                                <label class="control-label" for="loginId">${data.translateId("loginId")}</label>
                                <div class="">
                                    <input id="loginId" class="k-textbox"/>
                                </div>
                            </div>
                        </div>
                        <div class="form-horizontal form-widgets col-md-8 col-md-offset-2 clearfix">
                            <div class="form-group">
                                <label class="control-label" for="resetToken">${data.translateId("resetToken")}</label>
                                <div class="">
                                    <input id="resetToken" class="k-textbox"/>
                                </div>

                            </div>
                        </div>
                        <div class="form-horizontal form-widgets col-md-8 col-md-offset-2 clearfix">
                            <div class="form-group">
                                <label class="control-label" for="newPassword">${data.translateId("newPassword")}</label>
                                <div class="">
                                    <input id="newPassword" type="password" class="k-textbox"/>
                                </div>
                            </div>
                        </div>
                        <div class="form-horizontal form-widgets col-md-8 col-md-offset-2 clearfix">
                            <div class="form-group">
                                <label class="control-label" for="confirmNewPassword">${data.translateId("confirmNewPassword")}</label>
                                <div class="">
                                    <input id="confirmNewPassword" type="password" class="k-textbox"/>
                                </div>
                            </div>
                        </div>
                        <div class="form-horizontal form-widgets col-md-8 col-md-offset-2">
                            <div class="form-group">
                                <div class="buttons-wrap login-form">
                                    <button class="k-button k-state-default k-primary" id="resetPassword">${data.translateId("resetPassword")}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </section>
                </div>
            </div>
        </div>`;
}